<template>
    <b-sidebar :open="open" @close="$emit('sideBarClose')" fullheight right>
      <b-loading v-model="loggingOut" :is-full-page="false" />
      <div class="py-2 px-2">

        <div class="has-text-right py-2">
          <a @click.prevent="$emit('sideBarClose')" class="delete is-large"></a>
        </div>

        <div v-if="!isAdmin && !isModulesOnly" class="px-2 py-2 mb-2">
          <b-field label="Bankroll">
            <b-numberinput :loading="loading"
                           step="25"
                           v-model="bankroll"
                           size="is-default"
                           controls-position="compact"
                           controls-rounded />
          </b-field>
          <hr>
        </div>

        <b-menu :activable="false">
          <b-menu-list>
            <b-menu-item v-if="isAdmin && !isModulesOnly"
                         icon="format-list-checks"
                         @click.native="$emit('sideBarClose')"
                         tag="router-link"
                         to="/admin"
                         label="Services"
                         class="is-size-5" />

            <b-menu-item v-else-if="!isModulesOnly"
                         icon="currency-usd"
                         tag="router-link"
                         to="/"
                         label="Picks"
                         exact
                         @click.native="$emit('sideBarClose')"
                         class="is-size-5" />

            <b-menu-item v-if="hasModules"
                         icon="bookshelf"
                         tag="router-link"
                         to="/modules"
                         label="Learn"
                         exact
                         @click.native="$emit('sideBarClose')"
                         class="is-size-5" />

            <b-menu-item v-if="!isAdmin"
                         icon="cog"
                         tag="router-link"
                         to="/profile"
                         @click.native="$emit('sideBarClose')"
                         label="Settings"
                         class="is-size-5" />

            <b-menu-item v-if="!isAdmin && servicePhone"
                         @click.native="$emit('sideBarClose')"
                         icon="phone"
                         :label="servicePhone"
                         :href="`tel:${servicePhone}`"
                         class="is-size-5" />

            <b-menu-item @click.prevent="logout"
                         icon="logout"
                         label="Logout"
                         class="is-size-5" />
          </b-menu-list>
        </b-menu>
      </div>
    </b-sidebar>
</template>

<script>
import debounce from 'underscore/modules/debounce';
import { logout, updateProfile } from '@/utils/api';

export default {
  props: {
    open: Boolean,
    user: Object
  },
  data() {
    return {
      bankroll: undefined,
      loading: false,
      loggingOut: false,
      servicePhone: process.env.VUE_APP_PHONE || '',
      hasModules: process.env.VUE_APP_HAS_MODULES,
      isModulesOnly: process.env.VUE_APP_IS_MODULES_ONLY
    }
  },
  mounted() {
    let {user} = this;

    if (user.bankroll) {
      this.bankroll = parseFloat(user.bankroll || 0);
    }
  },
  methods: {
    logout: async function () {
      let { isAdmin } = this;

      this.loggingOut = true;
      await logout({isAdmin});
      this.loggingOut = false;
      localStorage.removeItem('user');
      this.$emit('sideBarClose');

      return this.$router.push('/login');
    },
    updateUser: debounce(function (edits) {
      this.loading = true;

      updateProfile({edits})
        .then(async res => {
          if (!res.ok) {
            return this.$buefy.toast.open({
              message: 'Could not update profile',
              type: 'is-danger'
            });
          }

          let resData = await res.json();

          if ('user' in resData) {
            localStorage.setItem('user', JSON.stringify(resData.user));
            this.$emit('userUpdated');
          }

          return this.$buefy.toast.open({
            message: 'Profile Updated',
            type: 'is-success'
          })
        })
        .catch(err => this.$buefy.toast.open({message: err.message, type: 'is-danger'}))
        .finally(() => this.loading = false);

    }, 700)
  },
  computed: {
    isAdmin: function () {
      return this.user.admin_id
    }
  },
  watch: {
    bankroll: function (newBankroll, oldBankroll) {
      if (oldBankroll === undefined) return;

      this.updateUser({bankroll: newBankroll});
    }
  }
};
</script>